import React from 'react'

import NotInterestedIcon from '@material-ui/icons/NotInterested';

function UploaderBoxEmpty() {
	return (
		<div className='simple-attachment__box empty'>
			<div className='attachment__box--header'>
				<div className='left-content'>
					<span className='view-button no-files' aria-label="No files were uploaded">
						<NotInterestedIcon color='primary' />
						NO FILES WERE UPLOADED
					</span>
				</div>
				<div className="right-content">			
				</div>
			</div>		
		</div>
	)
}

export default UploaderBoxEmpty;
